import moment from "moment";

export const convertTimeToDate = (value: string): string => {
    const initialMoment = moment(value, "HH:mm:ss");
    const initialDate = new Date();
    initialDate.setHours(initialMoment.hours());
    initialDate.setMinutes(initialMoment.minutes());
    return initialDate.toString();
};

export const isValidDateString = (dateString: string): boolean => {
    const cleanDateString = dateString.replace(/ /g, "");
    const checkDate = moment(cleanDateString, "DD/MM/YYYY");
    return cleanDateString.length === 10 && checkDate.isValid();
};
